import type { VoidFunctionComponent } from 'react';

import styles from './Divider.module.less';

/**
 * A horizontal divider. We need to apply style so that we
 * can override the default margin (from Bootstrap).
 */
export const Divider: VoidFunctionComponent = () => (
  <hr className={styles.divider} />
);
